<template>
  <section class="entrar">
    <div class="elementos">
      <img src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/app/faixa-brilhante.png" class="efeito" />
      <video src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/app/icone-3d-animado.mp4" autoplay muted loop playsinline preload="auto"></video>
      <h1>{{ state.titulo }}</h1>
    </div>
    <div class="quadro">
      <div class="titulo">
        <h2>
          LEVEL
          <span>MEMBER</span>
        </h2>
        <p>Crie sua conta gratuita na LevelMember e sinta a experiência de usar uma tecnologia superior na construção de Área de Membros</p>
      </div>
      <!-- <div class="google">
        <button>
          <Svgs nome="google-colorido" />
          <p>Criar conta com Google</p>
        </button>
      </div>
      <div class="divisor">
        <span></span>
        <p>ou</p>
      </div> -->
      <div class="campos">
        <Campo tipo="text" placeholder="Ex: João Pedro" completar="false" label="Nome e sobrenome" v-model="state.nome" />
        <Campo tipo="tel" placeholder="(00) 00000-0000" completar="phone" label="Seu whatsapp" mascara="(##) #####-####" v-model="state.whatsapp" />
        <Campo tipo="email" placeholder="email@email.com" completar="email" label="E-mail para acesso" v-model="state.email" />
        <Campo tipo="password" placeholder="senha#123" completar="new-password" senha label="Crie sua senha de acesso" v-model="state.senha" />
        <Campo tipo="password" placeholder="senha#123" completar="new-password" senha label="Repita a senha criada" v-model="state.confirmaSenha" @keyup.enter="criarConta()" />
        <div class="termos" @click="state.confirmarTermos = !state.confirmarTermos" :class="{ ativo: state.confirmarTermos }">
          <span>
            <Svgs nome="check" />
          </span>
          <p>
            Concordo com os
            <a href="https://levelmember.com/documentos/termos" target="_blank" @click.stop>Termos</a>
            ,
            <a href="https://levelmember.com/documentos/politica" target="_blank" @click.stop>Política</a>
            e
            <a href="https://levelmember.com/documentos/contrato" target="_blank" @click.stop>Adesão</a>
            da LevelMember
          </p>
        </div>
        <BotaoPrincipal nome="Criar conta e começar" :disabled="state.desabilitarBotao" @click="criarConta()" />
        <div class="testar">
          <p>Já tem conta?</p>
          <button @click="router.push('/')">Entre aqui</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { inject, reactive, onMounted } from 'vue'
import { helperValidacoes } from '@helpers'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import apiAutenticacao from '@/api/levelmember/api-autenticacao'
import BotaoPrincipal from '@/components/global/elementos/BotaoPrincipal.vue'
import Campo from '@/components/global/elementos/Campo.vue'
import Svgs from '@svgs'

const emitter = inject('emitter')
const router = useRouter()
const route = useRoute()

const state = reactive({
  nome: '',
  whatsapp: '',
  email: '',
  senha: '',
  confirmaSenha: '',
  origem: '',
  desabilitarBotao: false,
  confirmarTermos: false,
  frase: 'O melhor construtor de Área de Membros',
  titulo: ''
})

const escreverTexto = () => {
  let i = 0
  const intervalo = setInterval(() => {
    if (i < state.frase.length) {
      state.titulo += state.frase[i]
      i++
    } else {
      clearInterval(intervalo)
    }
  }, 100)
}

function validarDados() {
  let mensagem

  if (!state.nome || !state.whatsapp || !state.email || !state.senha || !state.confirmaSenha) mensagem = 'Por favor preencha todos os campos'
  else if (state.nome.length < 3) mensagem = "O campo 'nome' precisa de no mínimo 3 caracteres"
  else if (!helperValidacoes.email(state.email)) mensagem = 'Formato de email inválido'
  else if (state.whatsapp.length < 15) mensagem = 'Número de telefone inválido'
  else if (state.senha !== state.confirmaSenha) mensagem = 'Senhas não conferem'
  else if (state.senha.length < 6 || state.confirmaSenha.length < 6) mensagem = 'Senha precisa ter 6 caracteres'
  else if (!state.confirmarTermos) mensagem = 'Aceita os termos para criar sua conta'
  else return true

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: mensagem })
  return false
}

async function criarConta() {
  if (!validarDados()) return

  const payload = {
    nome: state.nome,
    email: state.email,
    senha: state.senha,
    origem: state.origem,
    contato: {
      whatsapp: state.whatsapp
    }
  }

  const payloadLogin = {
    email: state.email,
    senha: state.senha
  }

  try {
    state.desabilitarBotao = true
    await apiAutenticacao.registrar(payload)
    await fazerLogin(payloadLogin)
  } catch (error) {
    state.desabilitarBotao = false
    emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: error })
  }
}

async function fazerLogin(payload) {
  const resp = await apiAutenticacao.entrar(payload)
  localStorage.setItem('levelmember-produtor-token', resp.token)
  setTimeout(() => window.location.assign('/inicio'), 300)
}

const getDeviceInfo = () => {
  const ua = navigator.userAgent

  const isMobile = /iPhone|iPad|iPod|Android/i.test(ua)
  const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(ua)

  let deviceType = 'desktop'
  if (isMobile) deviceType = 'mobile'
  if (isTablet) deviceType = 'tablet'

  let browser = 'desconhecido'
  if (ua.includes('Chrome')) browser = 'chrome'
  if (ua.includes('Firefox')) browser = 'firefox'
  if (ua.includes('Safari') && !ua.includes('Chrome')) browser = 'safari'
  if (ua.includes('Edg')) browser = 'edge'
  if (ua.includes('Opera') || ua.includes('OPR')) browser = 'opera'

  return `${deviceType}, ${navigator.platform.toLowerCase()}, ${browser}`
}

onMounted(() => {
  const device = getDeviceInfo()
  const params = [route.query.origem ? `origem = ${route.query.origem}` : '', route.query.utm_campaign ? `utm_campaign = ${route.query.utm_campaign}` : '', route.query.utm_source ? `utm_source = ${route.query.utm_source}` : '', route.query.utm_medium ? `utm_medium = ${route.query.utm_medium}` : '', route.query.utm_content ? `utm_content = ${route.query.utm_content}` : '', route.query.utm_term ? `utm_term = ${route.query.utm_term}` : '', `dispositivo = ${device}`].filter(Boolean).join(', ')

  state.origem = params

  setTimeout(() => {
    escreverTexto()
  }, 2000)
})
</script>

<style scoped>
section.entrar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-color: var(--cor-preto);
  position: relative;
  padding: 200px 0 80px 0;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow-y: scroll;
}
img.efeito {
  position: absolute;
  left: 0;
  top: -450px;
  z-index: 2;
  width: 100%;
  pointer-events: none;
}
video {
  position: absolute;
  width: 100%;
  max-width: 220px;
  top: -20px;
  z-index: 1;
  background-color: var(--cor-preto);
  border: 10px solid var(--cor-preto);
  pointer-events: none;
  margin: 0 220px 0 0;
}
h1 {
  font-family: var(--semibold);
  font-size: var(--f4);
  color: transparent;
  background: linear-gradient(90deg, var(--degrade-texto));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  width: 100%;
  max-width: 300px;
  min-height: 140px;
  line-height: 1.2;
  position: absolute;
  top: 50px;
  margin: 0 0 0 220px;
  z-index: 3;
}
.quadro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  background-color: var(--cor-escuro-t);
  border: 2px solid var(--cor-escuro-3);
  padding: 40px;
  border-radius: 8px;
  z-index: 3;
}
.titulo {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.titulo h2 {
  display: flex;
  font-family: var(--semibold);
  font-size: var(--f4);
  color: var(--cor-gelo);
}
.titulo h2 span {
  font-family: var(--extralight);
}
.titulo svg {
  width: 150px;
  min-width: 150px;
  margin: 0 0 15px 0;
}
.titulo p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  line-height: 1.5;
  text-align: center;
  width: 100%;
  max-width: 300px;
  margin: 10px 0 20px 0;
}
.termos {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 15px 0;
}
.termos.ativo span {
  background-color: var(--cor-verde);
}
.termos span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background-color: var(--cor-escuro-3);
  margin: 0 5px 0 0;
  transition: all 0.3s;
}
.termos.ativo span svg {
  fill: var(--cor-branco);
}
.termos span svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-escuro-3);
  transition: all 0.3s;
}
.termos p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
}
.termos p a {
  cursor: pointer;
  font-family: var(--bold);
  color: var(--cor-marca);
  transition: all 0.3s;
}
.termos p a:hover {
  color: var(--cor-marca-escuro);
}
.google {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}
.google button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  border-radius: 8px;
  width: 100%;
  background-color: var(--cor-escuro-2);
  transition: all 0.3s;
}
.google button:hover {
  background-color: var(--cor-escuro-3);
}
.google button p {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.google button svg {
  width: 15px;
  min-width: 15px;
  margin: 0 10px 0 0;
}
.divisor {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  position: relative;
  z-index: 2;
  margin: 20px 0;
}
.divisor span {
  width: 100%;
  max-width: 300px;
  height: 2px;
  background-color: var(--cor-escuro-3);
  position: absolute;
  z-index: 1;
}
.divisor p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-4);
  background-color: var(--cor-escuro-1);
  padding: 0 20px;
  z-index: 2;
}
.campos {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}
.campos .campo {
  margin: 0 0 15px 0;
}
.campos .esqueceu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin: 0 0 15px 0;
}
.campos .esqueceu button {
  display: flex;
  align-items: center;
  background-color: transparent;
}
.campos .esqueceu button:hover p {
  color: var(--cor-branco-t);
}
.campos .esqueceu button:hover svg {
  fill: var(--cor-branco-t);
}
.campos .esqueceu button p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  transition: all 0.3s;
}
.campos .esqueceu button svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-branco);
  margin: 0 0 0 5px;
  transition: all 0.3s;
}
.campos .testar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 20px 0 0 0;
}
.campos .testar p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.campos .testar button {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  text-decoration: underline;
  margin: 0 0 0 5px;
  transition: all 0.3s;
}
.campos .testar button:hover {
  color: var(--cor-verde);
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.entrar {
    justify-content: center;
    align-items: flex-start;
    padding: 200px 10px 10px 10px;
  }
  img.efeito {
    left: 0;
    bottom: auto;
    top: 0px;
    width: 100%;
  }
  video {
    max-width: 220px;
    left: 0;
    top: -20px;
    border: 5px solid #000000;
    margin: 0;
  }
  h1 {
    font-size: var(--f3);
    max-width: 170px;
    min-height: 140px;
    line-height: 1.3;
    bottom: auto;
    top: 60px;
    left: 170px;
    margin: 0;
  }
  .quadro {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    right: auto;
    top: auto;
    padding: 50px 20px 50px 20px;
  }
  .ecosistema a {
    flex-direction: column;
    width: 33.33%;
    height: 80px;
  }
  .ecosistema a p {
    font-size: var(--f0);
  }
  .ecosistema a svg {
    width: 25px;
    height: 25px;
    margin: 0 0 10px 0;
  }
  .titulo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .titulo h2 {
    font-size: var(--f3);
  }
  .google button {
    padding: 20px;
  }
  .divisor {
    margin: 15px 0;
  }
  .divisor span {
    max-width: 250px;
  }
  .divisor p {
    padding: 0 15px;
  }
  .campos button.entrar {
    font-size: var(--f2);
  }
}
</style>
